/**
 * **브라우저 저장소(localStorage)에는 접속 정보를 남기지 않는다**(2026-10-07 사용자 요구: 「DB 연결 정보는 민감하므로 평문으로
 * 인식되지 않게」). 이 캐시는 새로고침 직후 목록·탐색기 트리를 바로 보여 주려는 것이라 이름·종류·트리만 있으면 된다 — 호스트·포트·
 * 계정·서비스명·SSH·접속 문자열은 서버가 다시 준다. **허용 목록**이다: 연결에 새 필드가 생기면 저장되지 않는 쪽으로 틀린다.
 * 로컬 전용·민감 연결은 이름조차 남기지 않는다(그 연결의 존재는 암호문 저장소에만 — services/localConnections).
 */
export const PERSISTED_CONNECTION_FIELDS = [
    'id', 'name', 'dbType', 'connType', 'folder', 'readOnly', 'builtin', 'type', 'children', 'isConnected',
    'sharedFrom', 'org', 'shared', 'color', 'description',
];
export const persistableConnection = (c) => Object.fromEntries(
    Object.entries(c || {}).filter(([k]) => PERSISTED_CONNECTION_FIELDS.includes(k)),
);
export const isLocalOnly = (c) => !!(c && (c.sensitive || c.storage === 'local' || /^local_/.test(String(c.id || ''))));

